import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

interface ChatMessage {
    role: 'system' | 'user' | 'assistant';
    content: string;
}

interface ChatCompletionsRequest {
    model: string;
    messages: ChatMessage[];
    temperature?: number;
    max_tokens?: number;
}

interface ChatCompletionsChoice {
    index: number;
    message: ChatMessage;
}

interface ChatCompletionsResponse {
    id: string;
    choices: ChatCompletionsChoice[];
}

@Injectable({ providedIn: 'root' })
export class AiCompletionService {
    private readonly defaultModel = 'gpt-4o-mini';
    private readonly defaultUrl = 'https://api.openai.com/v1/chat/completions';

    constructor(private http: HttpClient) { }

    private getApiKey(): string {
        // Admite environment.cvkeycht o environment.cvkeycheck.cvkeycheck
        const directKey: any = (environment as any).cvkeycht;
        const nestedKey: any = (environment as any).cvkeycheck && (environment as any).cvkeycheck.cvkeycheck;
        const apiKey = directKey || nestedKey;
        if (!apiKey) {
            throw new Error('No se encontró la API key en environment.cvkeycht ni en environment.cvkeycheck.cvkeycheck');
        }
        return apiKey;
    }

    private getApiUrl(): string {
        // Permite sobreescribir vía environment.aiApiUrl si existiera
        const url: any = (environment as any).aiApiUrl;
        return url || this.defaultUrl;
    }

    private getModel(): string {
        const model: any = (environment as any).aiModel;
        return model || this.defaultModel;
    }

    generateCompletion(descripcion: string, systemPrompt?: string, preguntasExtra?: string[]): Observable<string> {
        const apiKey = this.getApiKey();
        const url = this.getApiUrl();
        const model = this.getModel();

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${apiKey}`
        });

        const messages: ChatMessage[] = [];
        //const formatoForzado = 'Responde en el siguiente formato, listando cada pregunta y su respuesta en líneas separadas. Ejemplo:\n1) ¿Pregunta A?\nRespuesta...\n2) ¿Pregunta B?\nRespuesta...';
        const sys = (systemPrompt && systemPrompt.trim().length > 0 ? systemPrompt + '\\n' : '') + '';
        messages.push({ role: 'system', content: sys });

        let contenidoUsuario = descripcion;
        if (preguntasExtra && preguntasExtra.length > 0) {
            const enumeradas = preguntasExtra.map((p, i) => `${i + 1}) ${p}`).join('\n');
            contenidoUsuario += `\n\nContesta explícitamente a cada una de estas preguntas:\n${enumeradas}`;
        }
        messages.push({ role: 'user', content: contenidoUsuario });

        const body: ChatCompletionsRequest = {
            model,
            messages,
            temperature: 0.7,
            max_tokens: 512
        };

        return this.http.post<ChatCompletionsResponse>(url, body, { headers }).pipe(
            map(res => res?.choices?.[0]?.message?.content || '')
        );
    }
}


